import {action, extendObservable} from 'mobx';
import {FETCH_URL} from "../constants/ServerLinks";

class Metrics {

    constructor({metrics = []}) {
        extendObservable(this, metrics);
        this.apiUrl = FETCH_URL + '/api/v1/metrics/?sector_id='
    }

    @action
    fetchMetrics = async (cityId, sector_id) => {
        console.log("City ID " + cityId + " sector_id " + sector_id)
        if(cityId){
        const response = await fetch(FETCH_URL + `/api/v1/metrics/?city_id=${cityId.toString()}`);
        const db_metrics = await response.json();
        this.metrics = db_metrics.data;
        console.group("Metrics:fetchMetrics");
        console.log('data', JSON.stringify(db_metrics));
        console.groupEnd();
        } else {
        const response = await fetch(`${this.apiUrl}${sector_id.toString()}`);
        const db_metrics = await response.json();
        this.metrics = db_metrics.data;
        console.group("Metrics:fetchMetrics");
        console.log('data', JSON.stringify(db_metrics));
        console.groupEnd();
        }
        

        
    };

}

export default Metrics;
